import React from 'react';
import ClockIcon from '@atlaskit/icon/core/clock';
var RelatedLinksActionIcon = function RelatedLinksActionIcon() {
  return /*#__PURE__*/React.createElement(ClockIcon, {
    color: "currentColor",
    spacing: "spacious",
    label: "View related links..."
  });
};
export default RelatedLinksActionIcon;